import Card from "components/Card/Card";
// import { useHistory } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import Select from "react-select";
// import moment from "react-big-calendar/lib/localizers/moment";
import {
  Button,
  Col,
  Row,
  Table,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  Pagination,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";
import {
  AddToInventory,
  getAllPoList,
  GetPoListById,
  SendToXero,
  DeletePurchaseOrder,
  downloadingPurchaseOrder,
  StatusCheck,
  AddToInventoryStock,
  getBrachDetailsCountryCodeWise,
  getStoreWise,
  getStoreWiseWarehouse,
  RemoveAttachment,
  searchMedicationForPurchaseOrder,
} from "../../../Listfunction";
import { useHistory } from "react-router";
import Datetime from "react-datetime";
import { isExpressionWithTypeArguments } from "typescript";
import NotificationSystem from "react-notification-system";
import Swal from "sweetalert2";
import DateRangePicker from "react-daterange-picker";
import BarcodeInput from "./barcode";
import { useReactToPrint } from "react-to-print";
import ScreenLoader from "views/Components/screenLoader";
import { downloadingGoodsReceiveNote } from "api/purchaseOrder/PurchaseOrder";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import AttachmentModal from "./attachmentModal";
import ViewPoMedicine from "./ViewPoMedicine";
import AsyncSelect from "react-select/lib/Async";

const PoList = (props) => {
  const barcodenotification = <Tooltip id="remove">Generate Barcode</Tooltip>;
  const handlrTimeZone = (created_at) => {
    const utcMoment = moment.utc(created_at);
    const localMoment = utcMoment.local();
    return localMoment.format("YYYY-MM-DD HH:mm:ss A");
  };
  const _notificationSystem = React.createRef();
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const store_id = token.store_id;
  const userAccess = token.role;

  const [poList, setPoList] = useState();
  const [poListById, setPoListById] = useState();
  const [loading, setLoading] = useState(false);
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [addToInventoryModal, setAddToInventoryModal] = useState(false);
  const [isdaterangepickerOpen, setisdaterangepickerOpen] = useState(false);
  const [selecttedRange, setIaSelecttedRange] = useState("");
  const [attachment, setAttachment] = useState([]);
  const [attachmentError, setAttachmentError] = useState(null);
  const [poId, setPoId] = useState();
  const [searchParam, setSearchParam] = useState("");
  const [value, setvalue] = useState("");
  const [addToInventoryValues, setAddToInventoryValues] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [order_status, setOrderStatus] = useState("");
  const [to_date, setToDate] = useState("");
  const [from_date, setFromDate] = useState("");
  const barcodeRef = useRef();
  const [openGRNModal, setOpenGRNModal] = useState(false);
  const [isPDFLoading, setIsPDFLoading] = useState(false);
  const [isGRNLoading, setIsGRNLoading] = useState(false);
  const [confirmPrice, setConfirmPrice] = useState(false);
  const [confirmQty, setConfirmQty] = useState(false);
  const [confirmBonus, setConfirmBonus] = useState(false);
  const [storeList, setStoreList] = useState([]);
  const [store, setStore] = useState("");
  const [getStore, setGetStore] = useState("");
  const [storeError, setStoreError] = useState(null);
  const [selectStoreWise, setSelectStoreWise] = useState([]);
  const [selectWarehouseWise, setSelectWarehouseWise] = useState([]);
  const [addToInventoryModalNew, setAddToInventoryModalNew] = useState(false);
  const [openAttachmentModal, setOpenAttachmentModal] = useState(false);
  const [viewMedicineModal, setViewMedicineModal] = useState(false);
  const [poDetailsForAttachment, setPoDetailsForAttachment] = useState(null);
  const [poListDataById, setPoListDataById] = useState({});
  const [medicineFilter, setMedicineFilter] = useState(null);
  const [isInventorySubmitting, setIsInventorySubmitting] = useState(false);
  const inventorySubmitInProgressRef = useRef(false);

  const startInventorySubmission = () => {
    if (inventorySubmitInProgressRef.current) {
      return false;
    }

    inventorySubmitInProgressRef.current = true;
    setIsInventorySubmitting(true);
    return true;
  };

  const finishInventorySubmission = () => {
    inventorySubmitInProgressRef.current = false;
    setIsInventorySubmitting(false);
  };

  // <SweetAlert
  //   warning
  //   style={{ display: "block", marginTop: "-100px" }}
  //   title="Are you sure?"
  //   onConfirm={() => selectedPo(poId)}
  //   onCancel={() => EdithideAlert()}
  //   confirmBtnBsStyle="info"
  //   cancelBtnBsStyle="danger"
  //   confirmBtnText="Yes"
  //   cancelBtnText="Cancel"
  //   showCancel
  // >
  //   You want to edit this package ?
  // </SweetAlert>

  // const MySwal = withReactContent(Swal);

  const handleCLick = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to edit this PO</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        editPO(id);
      }
    });
  };
  const handleNewCLick = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to edit this PO</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        editPONew(id);
      }
    });
  };
  const handleCLickDelete = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to delete this PO</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePO(id);
      }
    });
  };

  const handleSendToXero = (id, amount) => {
    const maximumValue = 10000;
    let text = "";
    let header = "";
    if (amount >= maximumValue) {
      text =
        "The total value of this Purchase Order exceeds 10,000, You want to send this PO to Xero.";
      header = "High-Value Purchase Order";
    } else {
      text = "You want to send this PO to Xero.";
      header = "Are Sure";
    }
    Swal.fire({
      width: "500px",
      title: `<strong><font size='28px'>${header}</font></strong>`,
      icon: "info",
      html: `<font size='4px'>${text}</font>`,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        validateXero(id);
      }
    });
  };

  const validateXero = (id) => {
    const POById = poList.data.find((data) => id === data.id);
    const isValidate = POById.items.filter(
      (item) => item.account === "0" || item.deals === null,
    );
    if (isValidate.length !== 0) {
      Swal.fire({
        width: "500px",
        title: "<strong><font size='36px'>WARNING</font></strong>",
        icon: "info",
        html: "<font size='4px'>Please Select the Accounts and Deals Correctly</font>",
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        cancelButtonText: "<font size='4px'>OK</font>",
      });
    } else {
      sendToXero(id);
    }
  };

  const handleStoreList = () => {
    getBrachDetailsCountryCodeWise(token.country_code, obj).then((res) => {
      const storeList = res.data.map((store) => ({
        value: store.id,
        label: store.name,
      }));
      setStoreList(storeList);
    });
  };
  const getStoreList = () => {
    getStoreWise(token.country_code, obj).then((res) => {
      const store = res.data || [];
      const storeLists = store.map((store) => ({
        value: store.id,
        label: store.name,
      }));
      setSelectStoreWise(storeLists);
    });
  };
  const getStoreWiseData = () => {
    const typeParam = userAccess == 1 ? "" : "warehouse";
    getStoreWiseWarehouse(token.country_code, obj, typeParam).then((res) => {
      const warehouse = res.data || [];
      const warehouseLists = warehouse.map((warehouse) => ({
        value: warehouse.id,
        label: warehouse.name,
        type: warehouse.type,
      }));
      setSelectWarehouseWise(warehouseLists);
      if (userAccess != 1) {
        const defaultWarehouse = warehouseLists.find(
          (item) => item.type === "warehouse",
        );
        if (defaultWarehouse) {
          setGetStore(defaultWarehouse);
        }
      }
    });
  };

  // const history = useHistory();
  const addPO = () => {
    props.history.push("/admin/addPo");
  };
  const addPONew = () => {
    props.history.push("/admin/addPoNew");
  };

  // Initialize the hook at the top level of the component
  const handlePrint = useReactToPrint({
    content: () => {
      // The index will be set dynamically before calling this function
      return barcodeRef.current[handlePrint.index];
    },
  });

  const onPrintClick = (index) => {
    handlePrint.index = index; // Set the index before calling handlePrint
    handlePrint(); // Call the print function
  };

  const validateIsViewableFile = (id, amount, status) => {
    // const maximunValue = 150000;
    // if (amount >= maximunValue && (status == "pending" || status == "draft")) {
    //   Swal.fire({
    //     width: "500px",
    //     title: "<strong><font size='36px'>WARNING</font></strong>",
    //     icon: "warning",
    //     html: "<font size='4px'>PO was not approved Please sync again</font>",
    //     showCloseButton: false,
    //     showCancelButton: false,
    //     focusConfirm: false,
    //     cancelButtonText: "<font size='4px'>OK</font>",
    //   });
    // } else {
    handleView(id);
    // }
  };

  const handleView = async (id) => {
    setIsPDFLoading(true); // Start loading
    const notification = _notificationSystem.current;
    try {
      const res = await downloadingPurchaseOrder(obj, id);
      const ddata = res.data.pdf_url;

      if (ddata) {
        window.open(ddata, "_blank");
      } else {
        notification.addNotification({
          title: <span data-notify="icon">PDF URL not found</span>,
          message: <div>Something went wrong</div>,
          level: "warning",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } catch (error) {
      console.error("Error downloading purchase order:", error);
      notification.addNotification({
        title: (
          <span data-notify="icon">Error downloading purchase order:</span>
        ),
        message: <div>Something went wrong</div>,
        level: "warning",
        position: "bl",
        autoDismiss: 15,
      });
    } finally {
      setIsPDFLoading(false);
    }
  };

  const handleViewGRN = async (id) => {
    setIsGRNLoading(true); // Start loading
    const notification = _notificationSystem.current;
    try {
      const res = await downloadingGoodsReceiveNote(obj, id);
      const ddata = res.data.pdf_url;

      if (ddata) {
        window.open(ddata, "_blank");
      } else {
        notification.addNotification({
          title: <span data-notify="icon">PDF URL not found</span>,
          message: <div>Something went wrong</div>,
          level: "warning",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } catch (error) {
      console.error("Error downloading purchase order:", error);
      notification.addNotification({
        title: (
          <span data-notify="icon">Error downloading purchase order:</span>
        ),
        message: <div>Something went wrong</div>,
        level: "warning",
        position: "bl",
        autoDismiss: 15,
      });
    } finally {
      setIsGRNLoading(false);
    }
  };

  const sendToXero = async (id) => {
    const notification = _notificationSystem.current;
    const res = await SendToXero(obj, id);
    if (res.success === true) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>PO</b> - Sent To Xero Successfully .
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });
      getAllPurchaseOrders();
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.message}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const editPO = (id) => {
    props.history.push(`/admin/editPo/${id}`);
    localStorage.setItem("poId", id);
    // const id = token.token;
  };
  const editPONew = (id) => {
    props.history.push(`/admin/editPoNew/${id}`);
    localStorage.setItem("poId", id);
    // const id = token.token;
  };
  const deletePO = async (id) => {
    const notification = _notificationSystem.current;
    const res = await DeletePurchaseOrder(id, obj);
    if (res.success === true) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>PO</b> - Deleted Successfully .
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });
      getAllPurchaseOrders();
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.message}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };
  const handleSyncStatus = async () => {
    const notification = _notificationSystem.current;
    const res = await StatusCheck(obj);
    if (res.success === true) {
      setTimeout(() => {
        getAllPurchaseOrders();
      }, 10000);
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.message}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const onToggle = () => {
    setisdaterangepickerOpen(!isdaterangepickerOpen);
  };

  const getAllPurchaseOrders = (
    page = currentPage,
    selectedStore = store,
    selectedMedicine = medicineFilter,
  ) => {
    setLoading(true);
    const to_date =
      selecttedRange != ""
        ? moment(selecttedRange.end).format("YYYY-MM-DD")
        : "";
    const from_date =
      selecttedRange != ""
        ? moment(selecttedRange.start).format("YYYY-MM-DD")
        : "";
    getAllPoList(
      obj,
      page,
      searchParam,
      order_status,
      from_date,
      to_date,
      store_id === null ? "" : "",
      selectedStore ? selectedStore.value : "",
      selectedMedicine ? selectedMedicine.value : "",
    ).then((res) => {
      setPoList(res.data);
      setCurrentPage(res.data.pagination.current_page);
      setTotalPage(res.data.pagination.total_pages);
      setLoading(false);
    });
  };
  const loadMedicineFilterOptions = (inputValue) => {
    if (!inputValue || inputValue.trim().length < 2) {
      return Promise.resolve([]);
    }

    return searchMedicationForPurchaseOrder(inputValue.trim(), obj)
      .then((res) => {
        const medicineData =
          res && res.data && Array.isArray(res.data.data) ? res.data.data : [];

        return medicineData.map((medicine) => ({
          value: medicine.id,
          label: `${medicine.title || medicine.medication_name} (${medicine.item_code})`,
        }));
      })
      .catch(() => []);
  };
  useEffect(() => {
    handleStoreList();
    getAllPurchaseOrders();
    getStoreList();
    getStoreWiseData();
  }, []);

  const getAllPoDetails = async (currentPage) => {
    setCurrentPage(currentPage);
    getAllPurchaseOrders(currentPage);
  };

  const setBarcodeRefs = (el, index) => {
    if (!barcodeRef.current) {
      barcodeRef.current = {};
    }
    barcodeRef.current[index] = el;
  };
  //   const showAddToInventoryModalNew = async (id,files) => {
  //     if(files.length > 0 {
  //       setAddToInventoryModalNew(true);
  //       setPoId(id);
  //       await GetPoListById(id, obj).then((res) => {
  //             const data = res.data.data;
  //             setPoListById(data);

  //             const medicationItems = data.items
  //               .filter((item) => item.id)
  //               .map((poItem) => {
  //                 const requestQty =
  //                   Number(poItem.quantity || 0) + Number(poItem.free_of_goods || 0);

  //                 const unitPrice = parseFloat(JSON.parse(poItem.price).toFixed(2));
  //                 let marginPercentage = 0;
  //                 let marginColor = "";
  //                 let rangeLabel = "";

  //                 if (unitPrice > 0 && !isNaN(poItem.selling_price)) {
  //                   marginPercentage =
  //                     ((poItem.selling_price - unitPrice) * 100) / unitPrice;

  //                   if (marginPercentage < 10) {
  //                     marginColor = "red";
  //                     rangeLabel = "Below 10%";
  //                   } else if (marginPercentage < 15) {
  //                     marginColor = "orange";
  //                     rangeLabel = "10-15%";
  //                   } else if (marginPercentage < 20) {
  //                     marginColor = "green";
  //                     rangeLabel = "15-20%";
  //                   } else if (marginPercentage < 25) {
  //                     marginColor = "purple";
  //                     rangeLabel = "20-25%";
  //                   } else {
  //                     marginColor = "blue";
  //                     rangeLabel = "Above 25%";
  //                   }
  //                 }

  //                 return {
  //                   ...poItem,

  //                   // 🔑 GRN CORE
  //                   requestQty,
  //                   pendingQty: requestQty,
  //                   grnQty: 0,
  //                   batches: [],

  //                   // existing logic
  //                   selling_price: Number(poItem.selling_price),
  //                   sellingPriceError: null,
  //                   marginValue: marginPercentage.toFixed(2),
  //                   marginColor,
  //                   rangeLabel,

  //                   // UI-only batch input
  //                   batchInput: "",
  //                   batchInputError: null,
  //                   packSizeError: null,
  //                 };
  //               });
  //             });
  //             setAddToInventoryValues(medicationItems);
  //           // } catch (error) {
  //           //   console.error(error);
  //           // }
  //           setAttachmentError(null);
  //         };
  // } else {
  //       // sweet alert please attach the supplier invoice
  //       Swal.fire({
  //         width: "500px",
  //         title: "<strong><font size='36px'>Invoice Required</font></strong>",
  //         icon: "info",
  //         html: "<font size='4px'>Please attach the supplier invoice before processing GRN.</font>",
  //         showCloseButton: true,
  //         showCancelButton: false,
  //         focusConfirm: false,
  //         confirmButtonText: "<font size='4px'>OK</font>",
  //       });
  //     }
  const showAddToInventoryModalNew = async (id, files) => {
    try {
      // ✅ validate files safely
      // if (!files || files.length === 0) {
      //   Swal.fire({
      //     width: "500px",
      //     title: "<strong><font size='36px'>Invoice Required</font></strong>",
      //     icon: "info",
      //     html: "<font size='4px'>Please attach the supplier invoice before processing GRN.</font>",
      //     showCloseButton: true,
      //     showCancelButton: false,
      //     focusConfirm: false,
      //     confirmButtonText: "<font size='4px'>OK</font>",
      //   });
      //   return;
      // }

      // ✅ open modal
      setAddToInventoryModalNew(true);
      setPoId(id);

      // ✅ API call
      const res = await GetPoListById(id, obj);
      const data = res.data.data;

      setPoListById(data);

      // ✅ prepare medication items
      const medicationItems = (data.items || [])
        .filter((item) => item.id)
        .map((poItem) => {
          const requestQty =
            Number(poItem.quantity || 0) + Number(poItem.free_of_goods || 0);

          const unitPrice = parseFloat(JSON.parse(poItem.price).toFixed(2));

          let marginPercentage = 0;
          let marginColor = "";
          let rangeLabel = "";

          if (unitPrice > 0 && !isNaN(poItem.selling_price)) {
            marginPercentage =
              ((poItem.selling_price - unitPrice) * 100) / unitPrice;

            if (marginPercentage < 10) {
              marginColor = "red";
              rangeLabel = "Below 10%";
            } else if (marginPercentage < 15) {
              marginColor = "orange";
              rangeLabel = "10-15%";
            } else if (marginPercentage < 20) {
              marginColor = "green";
              rangeLabel = "15-20%";
            } else if (marginPercentage < 25) {
              marginColor = "purple";
              rangeLabel = "20-25%";
            } else {
              marginColor = "blue";
              rangeLabel = "Above 25%";
            }
          }

          return {
            ...poItem,

            // 🔑 GRN CORE
            requestQty,
            pendingQty: requestQty,
            grnQty: 0,
            batches: [],

            // existing logic
            selling_price: Number(poItem.selling_price),
            sellingPriceError: null,
            marginValue: marginPercentage.toFixed(2),
            marginColor,
            rangeLabel,

            // UI-only batch input
            batchInput: "",
            batchInputError: null,
            packSizeError: null,
          };
        });

      // ✅ set values AFTER mapping
      setAddToInventoryValues(medicationItems);
      setAttachmentError(null);
    } catch (error) {
      console.error("Error loading PO:", error);
    }
  };

  const showAddToInventoryModal = async (id, files) => {
    // if (files.length > 0) {
    setAddToInventoryModal(true);
    setPoId(id);

    await GetPoListById(id, obj).then((res) => {
      setPoListById(res.data.data);

      const medicationItems = res.data.data.items.filter(
        (medication) => medication.id,
      );

      setAddToInventoryValues(medicationItems);
      setAddToInventoryValues((prev) =>
        prev.map((poItem, index) => {
          const unitPrice = parseFloat(JSON.parse(poItem.price).toFixed(2));
          let marginPercentage = 0;
          let marginColor = "";
          let rangeLabel = "";
          if (unitPrice > 0 && !isNaN(poItem.selling_price)) {
            marginPercentage =
              ((poItem.selling_price - unitPrice) * 100) / unitPrice;
            if (marginPercentage < 10) {
              marginColor = "red";
              rangeLabel = "Below 10%";
            } else if (marginPercentage >= 10 && marginPercentage < 15) {
              marginColor = "orange";
              rangeLabel = "10-15%";
            } else if (marginPercentage >= 15 && marginPercentage < 20) {
              marginColor = "green";
              rangeLabel = "15-20%";
            } else if (marginPercentage >= 20 && marginPercentage < 25) {
              marginColor = "purple";
              rangeLabel = "20-25%";
            } else {
              marginColor = "blue";
              rangeLabel = "Above 25%";
            }
          }
          return {
            ...poItem,
            selling_price: Number(poItem.selling_price),
            sellingPriceError: null,
            marginValue: marginPercentage.toFixed(2),
            marginColor,
            rangeLabel,
          };
        }),
      );
    });
    setAttachmentError(null);
    // } else {
    //   // sweet alert please attach the supplier invoice
    //   Swal.fire({
    //     width: "500px",
    //     title: "<strong><font size='36px'>Invoice Required</font></strong>",
    //     icon: "info",
    //     html: "<font size='4px'>Please attach the supplier invoice before processing GRN.</font>",
    //     showCloseButton: true,
    //     showCancelButton: false,
    //     focusConfirm: false,
    //     confirmButtonText: "<font size='4px'>OK</font>",
    //   });
    // }
  };

  const handleExpiaryDateChange = (value, id, i) => {
    const expiaryDate = moment(value).format("YYYY-MM-DD");

    setAddToInventoryValues((prev) =>
      prev.map((poItem, index) => {
        if (index === i) {
          return {
            ...poItem,
            expiary_date: expiaryDate,
            expiaryDateError: null,
            isGoodReceived: 1,
          };
        }
        return poItem;
      }),
    );
  };

  const handleSellingPriceChange = (event, id, i) => {
    const sellingPrice = parseFloat(event.target.value);

    setAddToInventoryValues((prev) =>
      prev.map((poItem, index) => {
        if (index === i) {
          const unitPrice = parseFloat(JSON.parse(poItem.price).toFixed(2));
          let marginPercentage = 0;
          let marginColor = "";
          let rangeLabel = "";
          if (unitPrice > 0 && !isNaN(sellingPrice)) {
            marginPercentage = ((sellingPrice - unitPrice) * 100) / unitPrice;
            if (marginPercentage < 10) {
              marginColor = "red";
              rangeLabel = "Below 10%";
            } else if (marginPercentage >= 10 && marginPercentage < 15) {
              marginColor = "orange";
              rangeLabel = "10-15%";
            } else if (marginPercentage >= 15 && marginPercentage < 20) {
              marginColor = "green";
              rangeLabel = "15-20%";
            } else if (marginPercentage >= 20 && marginPercentage < 25) {
              marginColor = "purple";
              rangeLabel = "20-25%";
            } else {
              marginColor = "blue";
              rangeLabel = "Above 25%";
            }
          }
          return {
            ...poItem,
            selling_price: sellingPrice,
            sellingPriceError: null,
            marginValue: marginPercentage.toFixed(2),
            marginColor,
            rangeLabel,
          };
        }
        return poItem;
      }),
    );
  };

  // const handleMarginValue = (event, id, i) => {
  //   const marginValue = event.target.value;

  //   setAddToInventoryValues((prev) =>
  //     prev.map((poItem, index) => {
  //       if (index === i) {
  //         return {
  //           ...poItem,
  //           marginValue: marginValue,
  //         };
  //       }
  //       return poItem;
  //     })
  //   );
  // };

  const handleBarcodeChange = (event, id, i) => {
    const barcode = event.target.value;
    if (barcode.length == 13) {
      setAddToInventoryValues((prev) =>
        prev.map((poItem, index) => {
          if (index === i) {
            return {
              ...poItem,
              batch_no: barcode.substring(8, 13),
              barcode: barcode,
            };
          }
          return poItem;
        }),
      );
    } else {
      setAddToInventoryValues((prev) =>
        prev.map((poItem, index) => {
          if (index === i) {
            return {
              ...poItem,
              barcode: barcode,
            };
          }
          return poItem;
        }),
      );
    }
  };

  // const attachmentFileHandle = (event) => {
  //   const attachmentFile = event.target.files[0];

  //   setAttachment(attachmentFile);
  //   setAttachmentError(null);
  // };
  const handleSubmit = async () => {
    const fields = [];
    let poListByIdOld = [...addToInventoryValues];
    for (let i = 0; i < poListByIdOld.length; i++) {
      if (
        !poListByIdOld[i].selling_price ||
        poListByIdOld[i].selling_price === "0.00" ||
        Number(poListByIdOld[i].selling_price) === 0
      ) {
        if (!poListByIdOld[i].selling_price) {
          fields.push("Selling Price Required");
          poListByIdOld[i].sellingPriceError = (
            <small className="text-danger">Please enter Selling price</small>
          );
        }
      }
    }
    setAddToInventoryValues(poListByIdOld);
    if (fields.length === 0) {
      const notification = _notificationSystem.current;
      const addToInventoryValuesNew = addToInventoryValues.map((item) => ({
        ...item,
        selling_price: Number(item.selling_price).toFixed(2),
        unit_price: Number(item.price).toFixed(2),
        expiary_date: item.expiary_date ? item.expiary_date : null,
        isGoodReceived: item.isGoodsReceived ? item.isGoodsReceived : 1,
      }));
      if (!startInventorySubmission()) {
        return;
      }

      try {
        const res = await AddToInventoryStock(
          store_id,
          attachment,
          poId,
          addToInventoryValuesNew,
          obj,
        );
        if (res.data.success === true) {
          if (notification) {
            notification.addNotification({
              title: <span data-notify="icon" className="pe-7s-gift"></span>,
              message: (
                <div>
                  <b>Inventory</b> - Added Successfully .
                </div>
              ),
              level: "success",
              position: "bl",
              autoDismiss: 15,
            });
          } else {
            console.error("Notification system not initialized.");
          }
          setAddToInventoryModal(false);
          getAllPurchaseOrders();
        }
      } catch (err) {
        if (notification) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Something went wrong</b>
              </div>
            ),
            level: "error",
            position: "bl",
            autoDismiss: 15,
          });
        } else {
          console.error("Notification system not initialized.");
        }
      } finally {
        finishInventorySubmission();
      }
    }
  };
  const handleBatchInputChange = (e, index) => {
    const value = e.target.value;

    setAddToInventoryValues((prev) =>
      prev.map((item, i) =>
        i === index
          ? { ...item, batchInput: value, batchInputError: null }
          : item,
      ),
    );
  };
  const handlePackSizeChange = (e, index) => {
    const value = e.target.value;

    setAddToInventoryValues((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              pack_size: value,
              packSizeError:
                Number(value || 0) <= 0 ? (
                  <small className="text-danger">Pack size cannot be 0.</small>
                ) : null,
            }
          : item,
      ),
    );
  };
  const handleBatchScan = (medicineIndex) => {
    setAddToInventoryValues((prev) =>
      prev.map((item, index) => {
        if (index !== medicineIndex) return item;
        if (!item.batchInput) return item;

        const packQty = Number(item.pack_size || 0);
        if (packQty <= 0) {
          return {
            ...item,
            batchInput: "",
            packSizeError: (
              <small className="text-danger">Pack size cannot be 0.</small>
            ),
          };
        }

        const hasMissingExpiryInPreviousRows = prev
          .slice(0, medicineIndex)
          .some(
            (prevRow) =>
              Array.isArray(prevRow.batches) &&
              prevRow.batches.some(
                (batch) =>
                  !batch.expiry_date || !moment(batch.expiry_date).isValid(),
              ),
          );

        if (hasMissingExpiryInPreviousRows) {
          return {
            ...item,
            batchInput: "",
            batchInputError: "Fill previous expiry date",
          };
        }

        const pendingQty = Number(item.pendingQty || 0);
        const allowedQty =
          pendingQty > 0 ? Math.min(packQty, pendingQty) : packQty;
        if (allowedQty <= 0) return item;
        const batchNo = item.batchInput.trim();

        let duplicateLocation = "";
        for (let rowIndex = 0; rowIndex < prev.length; rowIndex++) {
          if (rowIndex === medicineIndex) continue;

          const otherItem = prev[rowIndex];
          if (!Array.isArray(otherItem.batches)) continue;

          const batchIndex = otherItem.batches.findIndex(
            (batch) =>
              String(batch.batch_no || "")
                .trim()
                .toLowerCase() === batchNo.toLowerCase(),
          );

          if (batchIndex !== -1) {
            duplicateLocation = `${rowIndex + 1}.${batchIndex + 1}`;
            break;
          }
        }

        if (duplicateLocation) {
          return {
            ...item,
            batchInput: "",
            batchInputError: `Batch code already used in ${duplicateLocation}`,
          };
        }

        // 🔍 check if batch already exists
        const existingBatchIndex = item.batches.findIndex(
          (b) => b.batch_no === batchNo,
        );
        let updatedBatches = [...item.batches];

        const hasMissingExpiryInExistingBatches =
          existingBatchIndex === -1 &&
          Array.isArray(item.batches) &&
          item.batches.some(
            (batch) =>
              !batch.expiry_date || !moment(batch.expiry_date).isValid(),
          );

        if (hasMissingExpiryInExistingBatches) {
          return {
            ...item,
            batchInput: "",
            batchInputError: "Add expiry before scan",
          };
        }
        if (existingBatchIndex !== -1) {
          // ✅ SAME BATCH → update qty only
          updatedBatches[existingBatchIndex] = {
            ...updatedBatches[existingBatchIndex],
            qty: updatedBatches[existingBatchIndex].qty + allowedQty,
          };
        } else {
          // ✅ NEW BATCH → add new row
          updatedBatches.push({
            medi_id: item.id,
            batch_no: batchNo,
            expiry_date: null,
            qty: allowedQty,
          });
        }

        return {
          ...item,
          grnQty: item.grnQty + allowedQty,
          pendingQty:
            pendingQty > 0 ? Math.max(pendingQty - allowedQty, 0) : pendingQty,
          batchInput: "", // clear input
          batchInputError: null,
          packSizeError: null,
          batches: updatedBatches,
        };
      }),
    );
  };
  const handleRemoveBatch = (medicineIndex, batchIndex) => {
    setAddToInventoryValues((prev) =>
      prev.map((item, i) => {
        if (i !== medicineIndex) return item;

        const batchToRemove = item.batches[batchIndex];
        if (!batchToRemove) return item;

        return {
          ...item,
          grnQty: item.grnQty - batchToRemove.qty,
          pendingQty: item.pendingQty + batchToRemove.qty,
          batches: item.batches.filter((_, idx) => idx !== batchIndex),
        };
      }),
    );
  };
  const handleExpiryChange = (medicineIndex, batchIndex, value) => {
    setAddToInventoryValues((prev) =>
      prev.map((item, i) => {
        if (i !== medicineIndex) return item;

        const updatedBatches = item.batches.map((batch, j) =>
          j === batchIndex
            ? {
                ...batch,
                expiry_date: value ? moment(value).format("YYYY-MM-DD") : null,
                expiryError: null,
              }
            : batch,
        );

        return { ...item, batches: updatedBatches, batchInputError: null };
      }),
    );
  };
  const handleSubmitNew = async () => {
    const fields = [];
    let poListByIdOld = [...addToInventoryValues];
    for (let i = 0; i < poListByIdOld.length; i++) {
      if (
        !poListByIdOld[i].selling_price ||
        poListByIdOld[i].selling_price === "0.00" ||
        Number(poListByIdOld[i].selling_price) === 0
      ) {
        if (!poListByIdOld[i].selling_price) {
          fields.push("Selling Price Required");
          poListByIdOld[i].sellingPriceError = (
            <small className="text-danger">Please enter Selling price</small>
          );
        }
      }
    }
    setAddToInventoryValues(poListByIdOld);
    if (fields.length === 0) {
      const notification = _notificationSystem.current;
      const addToInventoryValuesNew = addToInventoryValues.map((item) => ({
        ...item,
        selling_price: Number(item.selling_price).toFixed(2),
        unit_price: Number(item.price).toFixed(2),
        expiary_date: item.expiary_date ? item.expiary_date : null,
        isGoodReceived: item.isGoodsReceived ? item.isGoodsReceived : 1,
      }));
      if (!startInventorySubmission()) {
        return;
      }

      try {
        const res = await AddToInventoryStock(
          store_id,
          attachment,
          poId,
          addToInventoryValuesNew,
          obj,
        );
        if (res.data.success === true) {
          if (notification) {
            notification.addNotification({
              title: <span data-notify="icon" className="pe-7s-gift"></span>,
              message: (
                <div>
                  <b>Inventory</b> - Added Successfully .
                </div>
              ),
              level: "success",
              position: "bl",
              autoDismiss: 15,
            });
          } else {
            console.error("Notification system not initialized.");
          }
          setAddToInventoryModal(false);
          setAddToInventoryModalNew(false);
          getAllPurchaseOrders();
        }
      } catch (err) {
        if (notification) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Something went wrong</b>
              </div>
            ),
            level: "error",
            position: "bl",
            autoDismiss: 15,
          });
        } else {
          console.error("Notification system not initialized.");
        }
      } finally {
        finishInventorySubmission();
      }
    }
  };
  const handleOnSubmitNew = async () => {
    const fields = [];
    let poListByIdOld = [...addToInventoryValues];
    for (let i = 0; i < poListByIdOld.length; i++) {
      const itemBatches = Array.isArray(poListByIdOld[i].batches)
        ? poListByIdOld[i].batches
        : [];

      const validatedBatches = itemBatches.map((batch) => {
        const hasValidExpiry =
          !!batch.expiry_date && moment(batch.expiry_date).isValid();
        if (!hasValidExpiry) {
          fields.push("Expiry Date Required");
        }
        return {
          ...batch,
          expiryError: hasValidExpiry ? null : (
            <small className="text-danger" style={{ marginLeft: "5px" }}>
              expiry Date Required
            </small>
          ),
        };
      });

      poListByIdOld[i] = {
        ...poListByIdOld[i],
        batches: validatedBatches,
      };

      if (
        !poListByIdOld[i].selling_price ||
        poListByIdOld[i].selling_price === "0.00" ||
        Number(poListByIdOld[i].selling_price) === 0
        // !poListByIdOld[i].expiary_date ||
        // poListByIdOld[i].expiary_date == "Invalid date"
      ) {
        if (!poListByIdOld[i].selling_price) {
          fields.push("Selling Price Required");
          poListByIdOld[i].sellingPriceError = (
            <small className="text-danger">Please enter Selling price</small>
          );
        }
        // if (
        //   !poListByIdOld[i].expiary_date ||
        //   poListByIdOld[i].expiary_date == "Invalid date"
        // ) {
        //   fields.push("Expired Date Required");
        //   poListByIdOld[i].expiaryDateError = (
        //     <small className="text-danger">Please enter expiry date</small>
        //   );
        // }
      }
      // if (
      //   Number(poListByIdOld[i].selling_price) >
      //   Number(poListByIdOld[i].price) +
      //   Number(poListByIdOld[i].price) * 0.2
      // ) {
      //   const result = await Swal.fire({
      //     width: "500px",
      //     title: "<strong><font size='36px'>Are You Sure?</font></strong>",
      //     icon: "info",
      //     html: "<font size='4px'>Selling price has increased by 20% over the purchase price</font>",
      //     showCloseButton: true,
      //     showCancelButton: true,
      //     focusConfirm: false,
      //     confirmButtonText: "<font size='4px'>Yes</font>",
      //     cancelButtonText: "<font size='4px'>No</font>",
      //   });
      //   if (!result.isConfirmed) {
      //     return;
      //   }
      // }
    }

    setAddToInventoryValues(poListByIdOld);

    if (!getStore || !getStore.value) {
      fields.push("Store Required");
      setStoreError(
        <small className="text-danger">Please select warehouse</small>,
      );
    } else {
      setStoreError(null);
    }

    if (!attachment || attachment.length === 0) {
      fields.push("Attachment is Required");
      setAttachmentError(
        <small className="text-danger">Please Attach the Invoice</small>,
      );
    }

    if (fields.length === 0) {
      const notification = _notificationSystem.current;
      const addToInventoryValuesNew = addToInventoryValues.map((item) => ({
        ...item,
        selling_price: Number(item.selling_price).toFixed(2),
        unit_price: Number(item.price).toFixed(2),
        expiary_date: item.expiary_date ? item.expiary_date : null,
        isGoodReceived: item.isGoodsReceived ? item.isGoodsReceived : 1,
      }));
      if (!startInventorySubmission()) {
        return;
      }

      try {
        const res = await AddToInventory(
          attachment,
          poId,
          addToInventoryValuesNew,
          getStore && getStore.value ? getStore.value : store_id,
          obj,
        );
        if (res.data.success === true) {
          if (notification) {
            notification.addNotification({
              title: <span data-notify="icon" className="pe-7s-gift"></span>,
              message: (
                <div>
                  <b>Inventory</b> - Added Successfully .
                </div>
              ),
              level: "success",
              position: "bl",
              autoDismiss: 15,
            });
          } else {
            console.error("Notification system not initialized.");
          }
          setAddToInventoryModal(false);
          setAddToInventoryModalNew(false);
          getAllPurchaseOrders();
        }
      } catch (err) {
        if (notification) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Something went wrong</b>
              </div>
            ),
            level: "error",
            position: "bl",
            autoDismiss: 15,
          });
        } else {
          console.error("Notification system not initialized.");
        }
      } finally {
        finishInventorySubmission();
      }
    }
  };
  const handleOnSubmit = async () => {
    const fields = [];
    let poListByIdOld = [...addToInventoryValues];
    for (let i = 0; i < poListByIdOld.length; i++) {
      if (
        !poListByIdOld[i].selling_price ||
        poListByIdOld[i].selling_price === "0.00" ||
        Number(poListByIdOld[i].selling_price) === 0
        // !poListByIdOld[i].expiary_date ||
        // poListByIdOld[i].expiary_date == "Invalid date"
      ) {
        if (!poListByIdOld[i].selling_price) {
          fields.push("Selling Price Required");
          poListByIdOld[i].sellingPriceError = (
            <small className="text-danger">Please enter Selling price</small>
          );
        }
        // if (
        //   !poListByIdOld[i].expiary_date ||
        //   poListByIdOld[i].expiary_date == "Invalid date"
        // ) {
        //   fields.push("Expired Date Required");
        //   poListByIdOld[i].expiaryDateError = (
        //     <small className="text-danger">Please enter expiry date</small>
        //   );
        // }
      }
      // if (
      //   Number(poListByIdOld[i].selling_price) >
      //   Number(poListByIdOld[i].price) +
      //   Number(poListByIdOld[i].price) * 0.2
      // ) {
      //   const result = await Swal.fire({
      //     width: "500px",
      //     title: "<strong><font size='36px'>Are You Sure?</font></strong>",
      //     icon: "info",
      //     html: "<font size='4px'>Selling price has increased by 20% over the purchase price</font>",
      //     showCloseButton: true,
      //     showCancelButton: true,
      //     focusConfirm: false,
      //     confirmButtonText: "<font size='4px'>Yes</font>",
      //     cancelButtonText: "<font size='4px'>No</font>",
      //   });
      //   if (!result.isConfirmed) {
      //     return;
      //   }
      // }
    }

    setAddToInventoryValues(poListByIdOld);

    // if (attachment === undefined) {
    //   fields.push("Attachment is Required");
    //   setAttachmentError(
    //     <small className="text-danger">Please Attach the Invoice</small>
    //   );
    // }

    if (fields.length === 0) {
      const notification = _notificationSystem.current;
      const addToInventoryValuesNew = addToInventoryValues.map((item) => ({
        ...item,
        selling_price: Number(item.selling_price).toFixed(2),
        unit_price: Number(item.price).toFixed(2),
        expiary_date: item.expiary_date ? item.expiary_date : null,
        isGoodReceived: item.isGoodsReceived ? item.isGoodsReceived : 1,
      }));
      if (!startInventorySubmission()) {
        return;
      }

      try {
        const res = await AddToInventory(
          attachment,
          poId,
          addToInventoryValuesNew,
          store_id,
          obj,
        );
        if (res.data.success === true) {
          if (notification) {
            notification.addNotification({
              title: <span data-notify="icon" className="pe-7s-gift"></span>,
              message: (
                <div>
                  <b>Inventory</b> - Added Successfully .
                </div>
              ),
              level: "success",
              position: "bl",
              autoDismiss: 15,
            });
          } else {
            console.error("Notification system not initialized.");
          }
          setAddToInventoryModal(false);
          getAllPurchaseOrders();
        }
      } catch (err) {
        if (notification) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Something went wrong</b>
              </div>
            ),
            level: "error",
            position: "bl",
            autoDismiss: 15,
          });
        } else {
          console.error("Notification system not initialized.");
        }
      } finally {
        finishInventorySubmission();
      }
    }
  };

  const uploadAttachment = () => {
    document.getElementById("attachment").click();
  };

  const attachmentFileHandle = (event) => {
    const fileArray = Array.from(event.target.files).map((file) => file);
    const result = fileArray.map((file) => {
      file["isNewFile"] = true;
      return file;
    });

    setAttachment((prev) => [...(Array.isArray(prev) ? prev : []), ...result]);
    setAttachmentError(null);
  };

  const handleRemoveAttachments = (name) => {
    const attachmentFile = [...attachment];
    let tempArray = [];
    tempArray.push(name);
    const fileArray = Array.from(tempArray);

    fileArray.map((file) => {
      if (file.isNewFile) {
        const removeFile = attachmentFile.filter((remove) => remove !== name);
        setAttachment(removeFile);
      } else {
        Swal.fire({
          width: "500px",
          title: "<strong><font size='36px'>Are Sure</font></strong>",
          icon: "info",
          html: "<font size='4px'>You want to remove this file permanently</font>",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: "<font size='4px'>Yes</font>",
          cancelButtonText: "<font size='4px'>No</font>",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const notification = _notificationSystem.current;
            const files = file.name;
            const res = await RemoveAttachment(obj, poId, files);
            if (res.success === true) {
              notification.addNotification({
                title: <span data-notify="icon" className="pe-7s-gift"></span>,
                message: (
                  <div>
                    <b>Attachment</b> - Removed Successfully.
                  </div>
                ),
                level: "success",
                position: "bl",
                autoDismiss: 15,
              });
              const removeFile = attachmentFile.filter(
                (remove) => remove !== name,
              );
              setAttachment(removeFile);
            } else {
              notification.addNotification({
                title: <span data-notify="icon" className="pe-7s-gift"></span>,
                message: (
                  <div>
                    <b>{res.data}</b>
                  </div>
                ),
                level: "error",
                position: "bl",
                autoDismiss: 15,
              });
            }
          }
        });
      }
    });
  };

  // const isSubmitEnabled = confirmPrice && confirmQty && confirmBonus;

  // Render a user-friendly pagination: show a window around the current page,
  // include first/last and ellipses when pages are omitted, and Prev/Next.
  const renderPagination = () => {
    if (!totalPage || totalPage <= 1) return null;

    const pages = [];
    const total = totalPage;
    const current = currentPage || 1;

    // Prev button
    pages.push(
      <Pagination.Prev
        key="prev"
        disabled={current === 1}
        onClick={() => current > 1 && getAllPoDetails(current - 1)}
      />,
    );

    // Determine sliding window (show up to 5 page numbers centered on current)
    let start = Math.max(1, current - 2);
    let end = Math.min(total, current + 2);

    // Expand window if we're near the edges
    if (current <= 3) {
      start = 1;
      end = Math.min(total, 5);
    }
    if (current >= total - 2) {
      end = total;
      start = Math.max(1, total - 4);
    }

    // First page + leading ellipsis
    if (start > 1) {
      pages.push(
        <Pagination.Item
          key={1}
          onClick={() => getAllPoDetails(1)}
          active={1 === current}
        >
          1
        </Pagination.Item>,
      );
      if (start > 2) {
        pages.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }
    }

    // Middle window
    for (let number = start; number <= end; number++) {
      pages.push(
        <Pagination.Item
          key={number}
          onClick={() => getAllPoDetails(number)}
          active={number === current}
        >
          {number}
        </Pagination.Item>,
      );
    }

    // Trailing ellipsis + last page
    if (end < total) {
      if (end < total - 1) {
        pages.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }
      pages.push(
        <Pagination.Item
          key={total}
          onClick={() => getAllPoDetails(total)}
          active={total === current}
        >
          {total}
        </Pagination.Item>,
      );
    }

    // Next button
    pages.push(
      <Pagination.Next
        key="next"
        disabled={current === total}
        onClick={() => current < total && getAllPoDetails(current + 1)}
      />,
    );

    return pages;
  };

  const yesterday = moment().subtract(1, "day");
  const disablePastDt = (current) => {
    return current.isAfter(yesterday);
  };

  const handleSearch = (event) => {
    const search = event.target.value;
    setSearchParam(search);
    getAllPurchaseOrders();
  };

  const handleFilter = () => {
    getAllPurchaseOrders();
  };
  const handleReset = () => {
    setSearchParam("");
    setOrderStatus("");
    setFromDate("");
    setToDate("");
    setIaSelecttedRange("");
    setMedicineFilter(null);
    setStore("");
    setTimeout(() => getAllPurchaseOrders(1, null, null), 100);
  };

  const handleAttachmentModalOpen = (item) => {
    if (item.files.length > 0) {
      setOpenAttachmentModal(true);
      setPoDetailsForAttachment(item);
    } else {
      Swal.fire({
        width: "500px",
        title: "<strong><font size='36px'>No Attachments</font></strong>",
        icon: "info",
        html: "<font size='4px'>There are no attachments for this purchase order.</font>",
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: "<font size='4px'>OK</font>",
      });
    }
  };
  const viewMedicineOrders = (itemId) => {
    setViewMedicineModal(true);
    GetPoListById(itemId, obj).then((res) => {
      setPoListDataById(res.data.data || []);
    });
  };
  const edit = <Tooltip id="edit">Edit</Tooltip>;
  const deleteTooltip = <Tooltip id="delete">Delete</Tooltip>;
  const addToInventoryTooltip = (
    <Tooltip id="add-to-inventory">Add to Inventory</Tooltip>
  );
  const addToInventoryTooltipNew = (
    <Tooltip id="add-to-inventory">Add to Inventory New</Tooltip>
  );
  const sendToXeroTooltip = <Tooltip id="send-to-xero">Send to Xero</Tooltip>;
  const attachmentTooltip = <Tooltip id="attachment">Attachment</Tooltip>;
  const ViewMedicineOrders = (
    <Tooltip id="view-medicine-orders">View Medicine Orders</Tooltip>
  );
  const goodsReceiveNoteTooltip = (
    <Tooltip id="goods-receive-note">Goods Receive Note</Tooltip>
  );
  return (
    <>
      <Col xs={12} sm={12} md={12} lg={12}>
        <NotificationSystem ref={_notificationSystem} />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className="text-right">
            <Button
              class="btn-color"
              style={{
                backgroundColor: "rgb(4 126 11)",
                marginTop: "25px",
                marginRight: "10px",
              }}
              // width="25%"  //bsStyle="info"
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              fill
              onClick={() => handleSyncStatus()}
            >
              Sync <i className="fa fa-sync"></i>
            </Button>
            <Button
              style={{
                marginTop: "25px",
                marginRight: "10px",
                display: "none",
              }}
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              onClick={() => addPO()}
            >
              Add PO <i className="fa fa-plus"></i>
            </Button>
            <Button
              style={{ marginTop: "25px", marginRight: "10px" }}
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              onClick={() => addPONew()}
            >
              ADD PO NEW<i className="fa fa-plus"></i>
            </Button>
            <br />
            &nbsp;
          </Col>
        </Row>
      </Col>
      <Col xs={12} sm={12} md={12} lg={12}>
        <NotificationSystem ref={_notificationSystem} />
        <Row
          className="po-list-filter-row"
          style={{
            padding: "20px 24px",
            border: "1px dashed #262626ff",
            borderRadius: "5px",
            margin: "10px 0px 20px 0px",
            display: "flex",
            alignItems: "flex-start",
            gap: "24px",
            flexWrap: "wrap",
          }}
        >
          <Col
            xs={12}
            sm={6}
            md={2}
            lg={2}
            className="text-left po-list-filter-field po-list-search-field"
            style={{ paddingLeft: 0, paddingRight: 0, width: "230px" }}
          >
            <FormControl
              style={{ position: "relative", width: "100%" }}
              name="search"
              value={searchParam}
              placeholder="Search"
              onChange={(event) => handleSearch(event)}
              type="text"
              className="text-input"
            />
          </Col>
          <Col
            xs={12}
            sm={6}
            md={3}
            lg={3}
            className="text-left po-list-filter-field po-list-medicine-field"
            style={{
              position: "relative",
              zIndex: 2,
              paddingLeft: 0,
              paddingRight: 0,
              width: "340px",
            }}
          >
            <AsyncSelect
              className="react-select primary"
              classNamePrefix="react-select"
              value={medicineFilter}
              onChange={(value) => setMedicineFilter(value)}
              loadOptions={loadMedicineFilterOptions}
              cacheOptions
              defaultOptions={false}
              placeholder="Select Medicine"
              isClearable
              noOptionsMessage={() => "Type medicine name"}
              menuPortalTarget={
                typeof document !== "undefined" ? document.body : null
              }
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 1040 }),
                menu: (base) => ({ ...base, zIndex: 1040 }),
              }}
            />
          </Col>
          <Col
            xs={12}
            sm={6}
            md={2}
            lg={2}
            className="text-left po-list-filter-field"
            style={{ paddingLeft: 0, paddingRight: 0, width: "230px" }}
          >
            <select
              onChange={(event) => setOrderStatus(event.target.value)}
              name="bulkSelect"
              value={order_status}
              placeholder="Select Status"
              className="form-control"
              style={{ height: "40px" }}
            >
              <option value="">Select Status</option>
              <option value="submitted">Draft</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="completed">Completed</option>
            </select>
          </Col>
          {userAccess == 1 && !addToInventoryModalNew && (
            <Col
              md={2}
              sm={6}
              lg={2}
              xs={12}
              className="text-left po-list-filter-field"
              style={{
                position: "relative",
                zIndex: 1,
                paddingLeft: 0,
                paddingRight: 0,
                width: "240px",
              }}
            >
              <Select
                options={storeList}
                value={store}
                onChange={(value) => {
                  setStore(value);
                  setCurrentPage(1);
                  getAllPurchaseOrders(1, value);
                }}
                placeholder="Select Store"
                isClearable
                menuPortalTarget={
                  typeof document !== "undefined" ? document.body : null
                }
                menuPosition="fixed"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 1040 }),
                  menu: (base) => ({ ...base, zIndex: 1040 }),
                }}
              />
            </Col>
          )}
          <Col
            md={2}
            sm={6}
            lg={2}
            xs={12}
            className="text-left po-list-filter-field po-list-date-field"
            style={{ paddingLeft: 0, paddingRight: 0, width: "150px" }}
          >
            <Button
              value="Toggle date picker"
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
              style={{
                backgroundColor: "white",
                color: "black",
                marginTop: 0,
                width: "100%",
              }}
              onClick={() => {
                onToggle();
              }}
            >
              Date Range
            </Button>
            {isdaterangepickerOpen && (
              <DateRangePicker
                value={selecttedRange}
                onSelect={(date) => setIaSelecttedRange(date)}
              />
            )}
          </Col>

          <Col
            md={2}
            sm={6}
            lg={2}
            xs={12}
            className="text-left po-list-filter-actions"
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              width: "190px",
              display: "flex",
              gap: "8px",
            }}
          >
            <Button
              class="btn-color"
              style={{ marginTop: 0, width: "90px", minWidth: "90px" }}
              // width="25%"  //bsStyle="info"
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              fill
              onClick={() => handleFilter()}
            >
              Filter
            </Button>
            {/* </Col>
          <Col xs={2} sm={2} md={2} lg={2} className="text-left"> */}
            <Button
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              onClick={() => handleReset()}
              style={{ marginTop: 0, width: "90px", minWidth: "90px" }}
            >
              Reset
            </Button>
          </Col>
          {/* <Col md={1} sm={1} lg={1} xs={12} className="text-left"></Col> */}
        </Row>
      </Col>
      <Col>
        <Card
          content={
            <React.Fragment>
              <Row>
                <Col md={12} sm={12} lg={12} xs={12}>
                  <div className="table-fixed-header desktop-table">
                    <div className="table-responsive">
                      <Table className="PO_list_table_show">
                        <thead>
                          <tr>
                            <th>Order ID</th>
                            <th>Po Number</th>
                            <th>Reference</th>
                            <th>Supplier</th>
                            <th>Date & Time</th>
                            <th>Delivery Date</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>View</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : noRecordFound ? (
                            <tr>
                              <td colSpan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            poList &&
                            poList.data.map((item, i) => (
                              <tr key={i}>
                                <td>{item.id}</td>
                                <td>{item.po_number}</td>
                                <td width="15%">
                                  {item.referance === null
                                    ? "-"
                                    : item.referance}
                                </td>
                                <td width="15%">{item.supplier_name}</td>
                                <td>{handlrTimeZone(item.created_at)}</td>
                                <td>
                                  {item.delivery_date === null
                                    ? "-"
                                    : moment(item.delivery_date).format(
                                        "YYYY-MMM-DD",
                                      )}
                                </td>
                                <td>{item.amount.toFixed(2)}</td>
                                <td>
                                  <Button
                                    className={`btn btn-fill ${
                                      item.order_status === "pending"
                                        ? "fl_text_orange"
                                        : item.order_status === "approved"
                                          ? "fl_text_blue"
                                          : item.order_status === "draft"
                                            ? "fl_text_purple"
                                            : "fl_text_green"
                                    }`}
                                    style={{
                                      // width: "100px",
                                      textTransform: "capitalize",
                                      cursor: "auto",
                                      fontSize: "10px",
                                      padding: "6px 12px",
                                    }}
                                  >
                                    {item.order_status}
                                  </Button>
                                </td>
                                {/* <td>
                              {item.files && item.files.length > 0
                                ? item.files.map((files, i) => (
                                    <a
                                      key={i}
                                      className="btn btn-fill fl_text_red"
                                      href={files.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ margin: "2px" }}
                                    >
                                      View{i + 1}
                                    </a>
                                  ))
                                : "-"}
                            </td> */}
                                <td>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-medicine-${item.id}`}
                                      >
                                        {item.items && item.items.length > 0
                                          ? item.items.map((med, index) => (
                                              <div key={index}>{med.name}</div>
                                            ))
                                          : "No medicine name"}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      onClick={() =>
                                        validateIsViewableFile(
                                          item.id,
                                          item.amount,
                                          item.order_status,
                                        )
                                      }
                                      style={{
                                        fontSize: "10px",
                                        padding: "6px 12px",
                                      }}
                                    >
                                      View
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                                <td>
                                  {item.order_status === "pending" ||
                                  item.order_status === "approved" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={addToInventoryTooltip}
                                    >
                                      <Button
                                        simple
                                        onClick={() =>
                                          showAddToInventoryModal(
                                            item.id,
                                            item.files,
                                          )
                                        }
                                        bsSize="md"
                                        style={{
                                          margin: "0px",
                                          border: "none",
                                          padding: "0px",
                                          display: "none",
                                        }}
                                      >
                                        <i className="fa fa-plus" />
                                      </Button>
                                    </OverlayTrigger>
                                  ) : null}
                                  {item.order_status === "pending" ||
                                  item.order_status === "approved" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={addToInventoryTooltipNew}
                                    >
                                      <Button
                                        simple
                                        onClick={() =>
                                          showAddToInventoryModalNew(
                                            item.id,
                                            item.files,
                                          )
                                        }
                                        bsSize="md"
                                        style={{
                                          margin: "0px",
                                          border: "none",
                                          padding: "0px",
                                          color: "red",
                                        }}
                                      >
                                        <i className="fa fa-plus" />
                                      </Button>
                                    </OverlayTrigger>
                                  ) : null}
                                  {item.order_status !== "completed" && (
                                    <>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={() => handleCLick(item.id)}
                                          bsSize="md"
                                          style={{
                                            margin: "0px",
                                            border: "none",
                                            padding: "0px",
                                            display: "none",
                                          }}
                                        >
                                          <i className="fa fa-pencil" />
                                        </Button>
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={() =>
                                            handleNewCLick(item.id)
                                          }
                                          bsSize="md"
                                          style={{
                                            margin: "0px",
                                            border: "none",
                                            padding: "0px",
                                            color: "red",
                                          }}
                                        >
                                          <i className="fa fa-pencil" />
                                        </Button>
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={deleteTooltip}
                                      >
                                        <Button
                                          simple
                                          bsStyle="danger"
                                          onClick={() =>
                                            handleCLickDelete(item.id)
                                          }
                                          bsSize="md"
                                          style={{
                                            margin: "0px",
                                            border: "none",
                                            padding: "0px",
                                          }}
                                        >
                                          <i className="fa fa-trash" />
                                        </Button>
                                      </OverlayTrigger>
                                    </>
                                  )}
                                  {item.order_status === "completed" && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={goodsReceiveNoteTooltip}
                                    >
                                      <Button
                                        simple
                                        // className="btn btn-fill fl_text_blue"
                                        onClick={() => handleViewGRN(item.id)}
                                        bsSize="md"
                                        style={{
                                          margin: "0px",
                                          border: "none",
                                          padding: "0px",
                                        }}
                                      >
                                        <i className="fas fa-file-alt" />
                                      </Button>
                                    </OverlayTrigger>
                                  )}
                                  {item.order_status === "draft" && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={sendToXeroTooltip}
                                    >
                                      <Button
                                        simple
                                        // className="btn btn-fill fl_text_blue"
                                        onClick={() =>
                                          handleSendToXero(item.id, item.amount)
                                        }
                                        bsSize="md"
                                        style={{
                                          margin: "0px",
                                          border: "none",
                                          padding: "0px",
                                        }}
                                      >
                                        <i className="fa fa-paper-plane" />
                                      </Button>
                                    </OverlayTrigger>
                                  )}
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={attachmentTooltip}
                                  >
                                    <Button
                                      simple
                                      // className="btn btn-fill fl_text_blue"
                                      onClick={() =>
                                        handleAttachmentModalOpen(item)
                                      }
                                      bsSize="md"
                                      style={{
                                        margin: "0px",
                                        border: "none",
                                        padding: "0px",
                                      }}
                                    >
                                      <i className="fa fa-paperclip" />
                                    </Button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={ViewMedicineOrders}
                                  >
                                    <Button
                                      simple
                                      // className="btn btn-fill fl_text_blue"
                                      onClick={() =>
                                        viewMedicineOrders(item.id)
                                      }
                                      bsSize="md"
                                      style={{
                                        margin: "0px",
                                        border: "none",
                                        padding: "0px",
                                      }}
                                    >
                                      <i className="fa fa-eye" />
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                                {/* {item.order_status === "pending" ||
                            item.order_status === "approved" ? (
                              <td>
                                <Button
                                  className="btn btn-fill fl_text_blue"
                                  onClick={() =>
                                    showAddToInventoryModal(item.id)
                                  }
                                >
                                  Add to inventory
                                </Button>
                              </td>
                            ) : (
                              <td></td>
                            )}
                            {item.order_status !== "completed" && (
                              <>
                                <td>
                                  <Button
                                    className="btn btn-fill fl_text_blue"
                                    onClick={() => handleCLick(item.id)}
                                  >
                                    Edit
                                  </Button>
                                </td>
                                <td>
                                  <Button
                                    className="btn btn-fill fl_text_red"
                                    onClick={() => handleCLickDelete(item.id)}
                                  >
                                    Delete
                                  </Button>
                                </td>
                              </>
                            )}
                            {item.order_status === "completed" && (
                              <td>
                                <Button
                                  className="btn btn-fill fl_text_blue"
                                  onClick={() => handleViewGRN(item.id)}
                                >
                                  Goods Receipt Note
                                </Button>
                              </td>
                            )}
                            {item.order_status === "draft" && (
                              <td>
                                <Button
                                  className="btn btn-fill fl_text_blue"
                                  onClick={() =>
                                    handleSendToXero(item.id, item.amount)
                                  }
                                >
                                  Send to Xero
                                </Button>
                              </td>
                            )} */}
                              </tr>
                            ))
                          )}
                        </tbody>
                      </Table>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Pagination bsSize="medium">
                        {renderPagination()}
                      </Pagination>
                    </div>
                  </div>

                  {/* Card view for mobile screens */}
                  <div className="card-container">
                    {loading ? (
                      <div>Loading...</div>
                    ) : noRecordFound ? (
                      <div>No record found</div>
                    ) : (
                      poList &&
                      poList.data.map((item, i) => (
                        <div key={i} className="card">
                          <div className="card-header">
                            PO Number: {item.po_number}
                          </div>
                          <div className="card-content">
                            <div>
                              Reference:{" "}
                              {item.referance === null ? "-" : item.referance}
                            </div>
                            <div>Supplier: {item.supplier_name}</div>
                            <div>
                              Date & Time: {handlrTimeZone(item.created_at)}
                            </div>
                            <div>
                              Delivery Date:{" "}
                              {item.delivery_date === null
                                ? "-"
                                : moment(item.delivery_date).format(
                                    "YYYY-MMM-DD",
                                  )}
                            </div>
                            <div>Amount: {item.amount.toFixed(2)}</div>
                            <div>
                              Status:
                              <Button
                                className={`btn btn-fill  ${
                                  item.order_status === "pending"
                                    ? "fl_text_orange"
                                    : item.order_status === "approved"
                                      ? "fl_text_blue"
                                      : item.order_status === "draft"
                                        ? "fl_text_purple"
                                        : "fl_text_green"
                                }`}
                                style={{ textTransform: "capitalize" }}
                              >
                                {item.order_status}
                              </Button>
                            </div>
                            <div>
                              Attachments:{" "}
                              {item.files && item.files.length > 0
                                ? item.files.map((files, i) => (
                                    <a
                                      key={i}
                                      href={files.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View{i + 1}
                                    </a>
                                  ))
                                : "-"}
                            </div>
                          </div>
                          Action: <br />
                          <div className="card-actions">
                            <Button
                              onClick={() =>
                                handleView(
                                  item.id,
                                  item.amount,
                                  item.order_status,
                                )
                              }
                            >
                              View
                            </Button>
                            {(item.order_status === "pending" ||
                              item.order_status === "approved") && (
                              <Button
                                className="btn btn-fill fl_text_blue"
                                onClick={() =>
                                  showAddToInventoryModal(item.id, item.files)
                                }
                              >
                                Add to inventory
                              </Button>
                            )}

                            {item.order_status !== "completed" && (
                              <>
                                <Button
                                  className="btn btn-fill fl_text_blue"
                                  onClick={() => handleCLick(item.id)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  className="btn btn-fill fl_text_red"
                                  onClick={() => handleCLickDelete(item.id)}
                                >
                                  Delete
                                </Button>
                              </>
                            )}
                            {item.order_status === "completed" && (
                              <Button
                                className="btn btn-fill fl_text_blue"
                                onClick={() => handleViewGRN(item.id)}
                              >
                                Goods Receipt Note
                              </Button>
                            )}
                            {item.order_status === "draft" && (
                              <Button
                                className="btn btn-fill fl_text_blue"
                                onClick={() =>
                                  handleSendToXero(item.id, item.amount)
                                }
                              >
                                Send to Xero
                              </Button>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {/* old */}
                  <Modal
                    show={addToInventoryModal}
                    onHide={() => setAddToInventoryModal(false)}
                    allowFullScreen
                    bsSize="large"
                    backdrop="static"
                    id="increaseWidth"
                  >
                    <Modal.Header>
                      <Modal.Title>
                        {`Add to inventory ${poListById ? poListById.id : ""}`}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <form>
                        <div className="table-responsive">
                          <Table className="fl_order_details">
                            <thead>
                              <tr>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  <ControlLabel>Supplier</ControlLabel>
                                </th>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  <ControlLabel>Invoice Number</ControlLabel>
                                </th>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  <ControlLabel>PO Number</ControlLabel>
                                </th>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  &nbsp;
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td align="center">
                                  <FormGroup>
                                    <FormControl
                                      type="text"
                                      name="supplier"
                                      placeholder="supplier Name"
                                      value={
                                        poListById && poListById.supplier_name
                                      }
                                      disabled
                                    />
                                  </FormGroup>
                                </td>
                                <td align="center">
                                  <FormGroup>
                                    <FormControl
                                      type="text"
                                      name=""
                                      InvoiceNumber
                                      placeholder="Invoice Number "
                                      value={
                                        poListById && poListById.invoice_no
                                      }
                                      disabled
                                    />
                                  </FormGroup>
                                </td>
                                <td align="center">
                                  <FormGroup>
                                    <FormControl
                                      type="text"
                                      name="po_number"
                                      placeholder="PO Number "
                                      value={poListById && poListById.po_number}
                                      disabled
                                    />
                                  </FormGroup>
                                </td>
                                <td align="center">
                                  &nbsp;
                                  {/* <Button
                                    onClick={() => uploadAttachment()}
                                    style={{
                                      color: "#2B3A41",
                                      marginTop: "10px",
                                    }}
                                  >
                                    {" "}
                                    <i
                                      className={
                                        attachment.length === 0
                                          ? "fa fa-plus"
                                          : "fa fa-pencil fa-fw"
                                      }
                                    ></i>{" "}
                                    {attachment.length === 0
                                      ? "Choose Attachment"
                                      : "Change Attachment"}
                                  </Button>
                                  <input
                                    style={{ display: "none" }}
                                    id="attachment"
                                    type="file"
                                    className="form-control"
                                    name="attachment"
                                    onChange={attachmentFileHandle}
                                  />
                                  <br />
                                  <br />
                                  {attachmentError} */}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                        <div className="table-responsive">
                          <Table className="fl_order_details">
                            <thead>
                              <tr>
                                <th
                                  align="center"
                                  width="10"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Item</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>B: No</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Barcode</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Qty</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Amount</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Expiry Date</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Selling price </ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Margin</ControlLabel>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {addToInventoryValues &&
                                addToInventoryValues.map((poItem, i) => (
                                  <tr>
                                    <>
                                      {/* <p>{poItem.expiaryDateError}</p> */}
                                      <td
                                        align="center"
                                        style={{ width: "10%" }}
                                      >
                                        <FormGroup>
                                          <FormControl
                                            type="text"
                                            name="name"
                                            placeholder="Medicine Item "
                                            value={poItem.name}
                                            disabled
                                          />
                                        </FormGroup>
                                      </td>
                                      <td
                                        align="center"
                                        style={{ width: "10%" }}
                                      >
                                        <FormGroup>
                                          <FormControl
                                            type="text"
                                            name="batch_no"
                                            placeholder="Batch No"
                                            value={poItem.batch_no}
                                            disabled
                                          />
                                        </FormGroup>
                                      </td>
                                      <td
                                        align="center"
                                        style={{ width: "7%" }}
                                      >
                                        <FormGroup>
                                          <FormControl
                                            type="text"
                                            name="barcode_no"
                                            placeholder="Barcode"
                                            onChange={(value) =>
                                              handleBarcodeChange(
                                                value,
                                                poItem.id,
                                                i,
                                              )
                                            }
                                            value={poItem.barcode}
                                            disabled={
                                              poItem.barcode !== null
                                                ? poItem.barcode[0] === "F"
                                                : false
                                            }
                                          />
                                        </FormGroup>
                                      </td>
                                      <td
                                        align="center"
                                        style={{ width: "7%" }}
                                      >
                                        <FormGroup>
                                          <FormControl
                                            type="text"
                                            name="qty"
                                            placeholder="Quantity "
                                            value={
                                              poItem.quantity +
                                              poItem.free_of_goods
                                            }
                                            disabled
                                          />
                                        </FormGroup>
                                      </td>
                                      <td
                                        align="center"
                                        style={{ width: "8%" }}
                                      >
                                        <FormGroup>
                                          <FormControl
                                            type="text"
                                            name="unit_price"
                                            placeholder="Unit Price "
                                            value={JSON.parse(
                                              poItem.price,
                                            ).toFixed(4)}
                                            disabled
                                          />
                                        </FormGroup>
                                      </td>
                                      {/* Expiry date column (desktop only) */}
                                      <td
                                        align="center"
                                        style={{ width: "8%" }}
                                        className="expiry-column"
                                      >
                                        <FormGroup>
                                          <Datetime
                                            timeFormat={false}
                                            dateFormat="YYYY-MM-DD"
                                            inputProps={{
                                              placeholder: "Expiary Date",
                                            }}
                                            closeOnSelect={true}
                                            onChange={(value) =>
                                              handleExpiaryDateChange(
                                                value,
                                                poItem.id,
                                                i,
                                              )
                                            }
                                            isValidDate={disablePastDt}
                                          />
                                          {poItem.expiaryDateError}
                                        </FormGroup>
                                      </td>
                                      <td
                                        align="center"
                                        style={{ width: "15%" }}
                                      >
                                        <FormGroup>
                                          <FormControl
                                            type="number"
                                            name="sellingPrice"
                                            placeholder="Selling Price "
                                            onChange={(e) =>
                                              handleSellingPriceChange(
                                                e,
                                                poItem.id,
                                                i,
                                              )
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            value={
                                              Number(poItem.selling_price) || ""
                                            }
                                          />
                                          {poItem.sellingPriceError}
                                        </FormGroup>
                                      </td>
                                      <td
                                        align="center"
                                        style={{ width: "15%" }}
                                      >
                                        <FormGroup>
                                          <FormControl
                                            type="text"
                                            name="marginValue"
                                            placeholder="Margin Value"
                                            value={
                                              poItem.marginValue &&
                                              poItem.rangeLabel
                                                ? `${poItem.marginValue}% (${poItem.rangeLabel})`
                                                : poItem.marginValue
                                                  ? `${poItem.marginValue}%`
                                                  : poItem.rangeLabel || ""
                                            }
                                            readOnly
                                            style={{
                                              color:
                                                poItem.marginColor || "black",
                                              fontWeight: "bold",
                                            }}
                                            aria-label="Margin Value"
                                          />
                                        </FormGroup>
                                      </td>
                                      {poItem.item_code &&
                                      (poItem.barcode !== null
                                        ? poItem.barcode.trim()[0] == "F"
                                        : true) ? (
                                        <>
                                          <td>
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={barcodenotification}
                                            >
                                              <Button
                                                onClick={() => onPrintClick(i)}
                                                style={{
                                                  border: "none",
                                                  marginBottom: "10px",
                                                }}
                                              >
                                                <i
                                                  class="fa fa-barcode"
                                                  aria-hidden="true"
                                                ></i>
                                              </Button>
                                            </OverlayTrigger>
                                          </td>
                                          <td style={{ display: "none" }}>
                                            <div
                                              ref={(ref) =>
                                                setBarcodeRefs(ref, i)
                                              }
                                              className="print-only"
                                            >
                                              <BarcodeInput
                                                name={poItem.name}
                                                itemcode={poItem.item_code}
                                              />
                                            </div>
                                          </td>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>

                        {/* Mobile card view inside modal - shows on small screens */}
                        <div className="modal-card-container">
                          {addToInventoryValues &&
                            addToInventoryValues.map((poItem, i) => (
                              <div className="modal-card" key={i}>
                                <div className="modal-card-header">
                                  <strong>{poItem.name}</strong>
                                </div>
                                <div className="modal-card-body">
                                  <div className="modal-card-row">
                                    <label>Batch No</label>
                                    <div>{poItem.batch_no || "-"}</div>
                                  </div>
                                  <div className="modal-card-row">
                                    <label>Barcode</label>
                                    <FormControl
                                      type="text"
                                      name="barcode_no"
                                      placeholder="Barcode"
                                      onChange={(e) =>
                                        handleBarcodeChange(e, poItem.id, i)
                                      }
                                      value={poItem.barcode}
                                      disabled={
                                        poItem.barcode !== null
                                          ? poItem.barcode[0] === "F"
                                          : false
                                      }
                                    />
                                  </div>
                                  <div className="modal-card-row">
                                    <label>Qty</label>
                                    <div>
                                      {poItem.quantity + poItem.free_of_goods}
                                    </div>
                                  </div>
                                  <div className="modal-card-row">
                                    <label>Unit Price</label>
                                    <div>
                                      {JSON.parse(poItem.price).toFixed(4)}
                                    </div>
                                  </div>
                                  {/* Expiry Date removed for mobile card view to match requested fields */}
                                  <div className="modal-card-row">
                                    <label>Selling Price</label>
                                    <FormControl
                                      type="number"
                                      name="sellingPrice"
                                      placeholder="Selling Price"
                                      onChange={(e) =>
                                        handleSellingPriceChange(
                                          e,
                                          poItem.id,
                                          i,
                                        )
                                      }
                                      value={Number(poItem.selling_price) || ""}
                                    />
                                    {poItem.sellingPriceError}
                                  </div>
                                  <div className="modal-card-row">
                                    <label>Margin</label>
                                    <div
                                      style={{
                                        color: poItem.marginColor || "black",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {poItem.marginValue && poItem.rangeLabel
                                        ? `${poItem.marginValue}% (${poItem.rangeLabel})`
                                        : poItem.marginValue
                                          ? `${poItem.marginValue}%`
                                          : poItem.rangeLabel || ""}
                                    </div>
                                  </div>
                                  {poItem.item_code &&
                                  (poItem.barcode !== null
                                    ? poItem.barcode.trim()[0] == "F"
                                    : true) ? (
                                    <div className="modal-card-row">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={barcodenotification}
                                      >
                                        <Button
                                          onClick={() => onPrintClick(i)}
                                          style={{ border: "none" }}
                                        >
                                          <i className="fa fa-barcode" />
                                        </Button>
                                      </OverlayTrigger>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      </form>
                    </Modal.Body>
                    <Modal.Footer>
                      {store_id === 1 || store_id === null ? (
                        <Button
                          onClick={() => handleOnSubmit()}
                          bsStyle="success"
                          fill
                          disabled={isInventorySubmitting}
                        >
                          {isInventorySubmitting ? "Submitting..." : "Submit"}
                        </Button>
                      ) : (
                        <Button
                          onClick={() => handleSubmit()}
                          bsStyle="success"
                          fill
                          disabled={isInventorySubmitting}
                        >
                          {isInventorySubmitting ? "Submitting..." : "Submit"}
                        </Button>
                      )}
                      <Button
                        bsStyle="danger"
                        fill
                        onClick={() => (
                          setAddToInventoryModal(false),
                          setAddToInventoryValues([]),
                          setConfirmPrice(false),
                          setConfirmQty(false),
                          setConfirmBonus(false)
                        )}
                      >
                        Cancel
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/* new */}
                  <Modal
                    show={addToInventoryModalNew}
                    onHide={() => setAddToInventoryModalNew(false)}
                    allowFullScreen
                    bsSize="large"
                    backdrop="static"
                    id="increaseWidth"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        {`Add to inventory ${poListById ? poListById.id : ""}`}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <form>
                        <div className="table-responsive">
                          <Table className="">
                            <thead>
                              <tr>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  <ControlLabel>Supplier</ControlLabel>
                                </th>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  <ControlLabel>Invoice Number</ControlLabel>
                                </th>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  <ControlLabel>PO Number</ControlLabel>
                                </th>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  <ControlLabel>
                                    Select warehouse{" "}
                                    <span
                                      className="required"
                                      style={{ color: "red" }}
                                    >
                                      *
                                    </span>
                                  </ControlLabel>
                                </th>
                                <th align="center" style={{ paddingLeft: 0 }}>
                                  Attachment
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td align="center" style={{ width: "25%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="text"
                                      name="supplier"
                                      placeholder="supplier Name"
                                      value={
                                        poListById && poListById.supplier_name
                                      }
                                      disabled
                                    />
                                  </FormGroup>
                                </td>
                                <td align="center" style={{ width: "25%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="text"
                                      name=""
                                      InvoiceNumber
                                      placeholder="Invoice Number "
                                      value={
                                        poListById && poListById.invoice_no
                                      }
                                      disabled
                                    />
                                  </FormGroup>
                                </td>
                                <td align="center" style={{ width: "22%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="text"
                                      name="po_number"
                                      placeholder="PO Number "
                                      value={poListById && poListById.po_number}
                                      disabled
                                    />
                                  </FormGroup>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <FormGroup
                                    style={{
                                      marginTop: storeError ? "20px" : "0px",
                                    }}
                                  >
                                    <Select
                                      options={selectWarehouseWise}
                                      value={getStore}
                                      onChange={(option) => {
                                        setGetStore(option);
                                        setStoreError(null);
                                      }}
                                      isClearable
                                      placeholder="Select warehouse"
                                    />
                                    {storeError}
                                  </FormGroup>
                                </td>
                                <td align="center">
                                  {/* &nbsp; */}
                                  <Button
                                    onClick={() => uploadAttachment()}
                                    style={{
                                      color: "#2B3A41",
                                      marginTop: "10px",
                                    }}
                                  >
                                    {" "}
                                    <i
                                      className={
                                        attachment.length === 0
                                          ? "fa fa-plus"
                                          : "fa fa-pencil fa-fw"
                                      }
                                    ></i>{" "}
                                    {attachment.length === 0
                                      ? "Choose Attachment"
                                      : "Change Attachment"}
                                  </Button>
                                  <input
                                    style={{ display: "none" }}
                                    id="attachment"
                                    type="file"
                                    className="form-control"
                                    name="attachment"
                                    onChange={attachmentFileHandle}
                                  />
                                  <br />
                                  <br />
                                  {attachmentError}
                                </td>
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>
                                  {" "}
                                  {attachment !== ""
                                    ? attachment.map((name, index) => (
                                        <>
                                          <span
                                            style={{
                                              background: "black",
                                              color: "white",
                                              padding: "10px",
                                            }}
                                            key={index}
                                          >
                                            <a
                                              href={URL.createObjectURL(name)}
                                              target="_blank"
                                            >
                                              {name.name}
                                            </a>
                                            <img
                                              onClick={() =>
                                                handleRemoveAttachments(name)
                                              }
                                              style={{
                                                padding: "5px",
                                                background: "transparent",
                                                cursor: "pointer",
                                                width: "20px",
                                                alignSelf: "flex-start",
                                              }}
                                              src="https://img.icons8.com/ios-glyphs/30/FFFFFF/delete-sign.png"
                                              alt="remove"
                                            />
                                          </span>
                                          <br />
                                          <br />
                                        </>
                                      ))
                                    : null}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                        <div className="table-responsive inventory-table">
                          <Table className="">
                            <thead>
                              <tr>
                                <th></th>
                                <th
                                  align="center"
                                  width="10"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Item</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Batch No</ControlLabel>
                                </th>

                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel> Request Qty</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Packs</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Amount</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Expiry Date</ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>
                                    Selling price{" "}
                                    <span
                                      className="required"
                                      style={{ color: "red" }}
                                    >
                                      *
                                    </span>
                                  </ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>Grn </ControlLabel>
                                </th>
                                <th
                                  align="center"
                                  style={{ textAlign: "center" }}
                                >
                                  <ControlLabel>pending</ControlLabel>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {addToInventoryValues &&
                                addToInventoryValues.map((poItem, i) => (
                                  <React.Fragment key={poItem.id || i}>
                                    <tr>
                                      <>
                                        <td style={{ textAlign: "center" }}>
                                          {i + 1}
                                        </td>
                                        <td
                                          align="center"
                                          style={{ width: "15%" }}
                                        >
                                          <FormGroup>
                                            <FormControl
                                              type="text"
                                              name="name"
                                              placeholder="Medicine Item "
                                              value={`${poItem.name} (${poItem.item_code})`}
                                              disabled
                                            />
                                          </FormGroup>
                                        </td>
                                        <td
                                          align="center"
                                          style={{ width: "13%" }}
                                        >
                                          <FormGroup>
                                            <FormControl
                                              type="text"
                                              placeholder="Scan Barcode"
                                              value={poItem.batchInput}
                                              onChange={(e) =>
                                                handleBatchInputChange(e, i)
                                              }
                                              onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                  handleBatchScan(i);
                                                }
                                              }}
                                            />
                                            {poItem.batchInputError && (
                                              <small
                                                style={{
                                                  color: "red",
                                                  display: "ruby",
                                                  marginRight: "65px",
                                                }}
                                              >
                                                {poItem.batchInputError}
                                              </small>
                                            )}
                                          </FormGroup>
                                        </td>

                                        <td
                                          align="center"
                                          style={{ width: "10%" }}
                                        >
                                          <FormGroup>
                                            <FormControl
                                              type="text"
                                              name="qty"
                                              placeholder="Quantity "
                                              value={
                                                poItem.quantity +
                                                poItem.free_of_goods
                                              }
                                            />
                                          </FormGroup>
                                        </td>
                                        <td
                                          align="center"
                                          style={{ width: "9%" }}
                                        >
                                          <FormGroup>
                                            <FormControl
                                              type="number"
                                              name="packs"
                                              placeholder="packs"
                                              value={poItem.pack_size}
                                              onChange={(e) =>
                                                handlePackSizeChange(e, i)
                                              }
                                              onWheel={(e) => e.target.blur()}
                                            />
                                            {poItem.packSizeError}
                                          </FormGroup>
                                        </td>
                                        <td
                                          align="center"
                                          style={{ width: "8%" }}
                                        >
                                          <FormGroup>
                                            <FormControl
                                              type="text"
                                              name="unit_price"
                                              placeholder="Unit Price "
                                              value={
                                                typeof poItem.price === "number"
                                                  ? poItem.price.toFixed(4)
                                                  : typeof poItem.price ===
                                                      "string"
                                                    ? parseFloat(
                                                        poItem.price,
                                                      ).toFixed(4)
                                                    : "0.00"
                                              }
                                              disabled
                                            />
                                          </FormGroup>
                                        </td>
                                        {/* Expiry date column (desktop only) */}
                                        {/* <td
                                        align="center"
                                        style={{ width: "8%" }}
                                        className="expiry-column"
                                      >
                                        <FormGroup>
                                          <Datetime
                                            timeFormat={false}
                                            dateFormat="YYYY-MM-DD"
                                            inputProps={{
                                              placeholder: "Expiary Date",
                                            }}
                                            closeOnSelect={true}
                                            onChange={(value) =>
                                              handleExpiaryDateChange(
                                                value,
                                                poItem.id,
                                                i,
                                              )
                                            }
                                            isValidDate={disablePastDt}
                                          />
                                          {poItem.expiaryDateError}
                                        </FormGroup>
                                      </td> */}
                                        <td
                                          align="center"
                                          style={{ width: "8%" }}
                                          className="expiry-column"
                                        >
                                          <FormGroup>
                                            <Datetime
                                              timeFormat={false}
                                              dateFormat="YYYY-MM-DD"
                                              inputProps={{
                                                placeholder: "Expiary Date",
                                              }}
                                              closeOnSelect={true}
                                              onChange={(value) =>
                                                handleExpiaryDateChange(
                                                  value,
                                                  poItem.id,
                                                  i,
                                                )
                                              }
                                              isValidDate={disablePastDt}
                                            />
                                            {poItem.expiaryDateError}
                                          </FormGroup>
                                        </td>
                                        <td
                                          align="center"
                                          style={{ width: "12%" }}
                                        >
                                          <FormGroup>
                                            <FormControl
                                              type="number"
                                              name="sellingPrice"
                                              placeholder="Selling Price "
                                              onChange={(e) =>
                                                handleSellingPriceChange(
                                                  e,
                                                  poItem.id,
                                                  i,
                                                )
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              value={
                                                Number(poItem.selling_price) ||
                                                ""
                                              }
                                            />
                                            <div
                                              style={{ marginRight: "16px" }}
                                            >
                                              {poItem.sellingPriceError}
                                            </div>
                                          </FormGroup>
                                        </td>
                                        <td
                                          align="center"
                                          style={{ width: "8%" }}
                                        >
                                          <FormGroup>
                                            <FormControl
                                              type="number"
                                              value={poItem.grnQty}
                                              style={
                                                Number(poItem.grnQty) > 0
                                                  ? {
                                                      border:
                                                        "2px solid #50B557",
                                                      backgroundColor:
                                                        "#E5FFE8",
                                                      fontWeight: "bold",
                                                      color: "black",
                                                    }
                                                  : {}
                                              }
                                              readOnly
                                            />
                                          </FormGroup>
                                        </td>
                                        <td
                                          align="center"
                                          style={{ width: "8%" }}
                                        >
                                          <FormGroup>
                                            <FormControl
                                              type="number"
                                              name="Pending"
                                              placeholder="Pending qty"
                                              value={poItem.pendingQty}
                                              style={
                                                Number(poItem.pendingQty) <
                                                Number(poItem.requestQty)
                                                  ? {
                                                      border: "2px solid red",
                                                      backgroundColor:
                                                        "#ffbfa8",
                                                      fontWeight: "bold",
                                                      color: "black",
                                                    }
                                                  : {}
                                              }
                                            />
                                          </FormGroup>
                                        </td>
                                        {poItem.item_code &&
                                        (poItem.barcode !== null
                                          ? poItem.barcode.trim()[0] == "F"
                                          : true) ? (
                                          <>
                                            <td>
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={barcodenotification}
                                              >
                                                <Button
                                                  onClick={() =>
                                                    onPrintClick(i)
                                                  }
                                                  style={{
                                                    border: "none",
                                                    marginBottom: "10px",
                                                  }}
                                                >
                                                  <i
                                                    class="fa fa-barcode"
                                                    aria-hidden="true"
                                                  ></i>
                                                </Button>
                                              </OverlayTrigger>
                                            </td>
                                            <td style={{ display: "none" }}>
                                              <div
                                                ref={(ref) =>
                                                  setBarcodeRefs(ref, i)
                                                }
                                                className="print-only"
                                              >
                                                <BarcodeInput
                                                  name={poItem.name}
                                                  itemcode={poItem.item_code}
                                                />
                                              </div>
                                            </td>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    </tr>
                                    {/* {poItem.batches &&
                                      Array.isArray(poItem.batches) &&
                                      poItem.batches.length > 0 && (
                                        <tr className="batch-header">
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f5f5f5",
                                              textAlign: "center",
                                            }}
                                          >
                                            Sr
                                          </td>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f5f5f5",
                                            }}
                                          >
                                            Medicine
                                          </td>

                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f5f5f5",
                                              textAlign: "center",
                                            }}
                                          >
                                            Batch No
                                          </td>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f5f5f5",
                                              textAlign: "center",
                                            }}
                                          >
                                            Expiry Date
                                          </td>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f5f5f5",
                                              textAlign: "center",
                                            }}
                                          >
                                            Qty
                                          </td>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f5f5f5",
                                            }}
                                            colSpan={2}
                                          ></td>
                                        </tr>
                                      )} */}

                                    {/* ================= BATCH ROWS ================= */}
                                    {poItem.batches &&
                                      Array.isArray(poItem.batches) &&
                                      poItem.batches.map((batch, bIndex) => (
                                        <tr key={bIndex} className="batch-row">
                                          <td style={{ textAlign: "center" }}>
                                            {`${i + 1}.${bIndex + 1}`}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {poItem.name}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {batch.batch_no}
                                          </td>
                                          <td>
                                            <Datetime
                                              dateFormat="YYYY-MM-DD"
                                              isValidDate={disablePastDt}
                                              inputProps={{
                                                placeholder: "Expiry Date",
                                                style: {
                                                  height: "34px",
                                                  fontSize: "14px",
                                                  padding: "6px 10px",
                                                  width: "180px",
                                                  border:
                                                    poItem.batchInputError &&
                                                    (!batch.expiry_date ||
                                                      !moment(
                                                        batch.expiry_date,
                                                      ).isValid())
                                                      ? "1px solid red"
                                                      : undefined,
                                                },
                                              }}
                                              timeFormat={false}
                                              closeOnSelect
                                              value={batch.expiry_date}
                                              onChange={(val) =>
                                                handleExpiryChange(
                                                  i,
                                                  bIndex,
                                                  val,
                                                )
                                              }
                                            />
                                            {batch.expiryError}
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "center",
                                              color: "#21dd21",
                                            }}
                                          >
                                            <span
                                              style={{
                                                backgroundColor: "#E5FFE8",
                                                border: "2px solid #50B557",
                                                fontWeight: "bold",
                                                color: "black",
                                                padding: "10px 40px",
                                                borderRadius: "5px",
                                              }}
                                            >
                                              {batch.qty}
                                            </span>
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "justify",
                                              padding: "10px",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            <button
                                              type="button"
                                              onClick={() =>
                                                handleRemoveBatch(i, bIndex)
                                              }
                                              title="Delete batch"
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                fontSize: "22px",
                                                lineHeight: 1,
                                                border: "none",
                                                background: "transparent",
                                                padding: 0,
                                              }}
                                              // class="btn btn-danger"
                                            >
                                              <i
                                                class="fa fa-trash-o"
                                                aria-hidden="true"
                                              ></i>
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                  </React.Fragment>
                                ))}
                            </tbody>
                          </Table>
                        </div>

                        {/* Mobile card view inside modal - shows on small screens */}
                        <div className="modal-card-container">
                          {addToInventoryValues &&
                            addToInventoryValues.map((poItem, i) => (
                              <div className="modal-card" key={i}>
                                <div className="modal-card-header">
                                  <strong>{poItem.name}</strong>
                                </div>
                                <div className="modal-card-body">
                                  <div className="modal-card-row">
                                    <label>Batch No</label>
                                    <div>{poItem.batch_no || "-"}</div>
                                  </div>
                                  <div className="modal-card-row">
                                    <label>Barcode</label>
                                    <FormControl
                                      type="text"
                                      name="barcode_no"
                                      placeholder="Barcode"
                                      onChange={(e) =>
                                        handleBarcodeChange(e, poItem.id, i)
                                      }
                                      value={poItem.barcode}
                                      disabled={
                                        poItem.barcode !== null
                                          ? poItem.barcode[0] === "F"
                                          : false
                                      }
                                    />
                                  </div>
                                  <div className="modal-card-row">
                                    <label>Qty</label>
                                    <div>
                                      {poItem.quantity + poItem.free_of_goods}
                                    </div>
                                  </div>
                                  <div className="modal-card-row">
                                    <label>Unit Price</label>
                                    <div>
                                      {typeof poItem.price === "number"
                                        ? poItem.price.toFixed(4)
                                        : typeof poItem.price === "string"
                                          ? parseFloat(poItem.price).toFixed(4)
                                          : "0.00"}
                                    </div>
                                  </div>
                                  {/* Expiry Date removed for mobile card view to match requested fields */}
                                  <div className="modal-card-row">
                                    <label>Selling Price</label>
                                    <FormControl
                                      type="number"
                                      name="sellingPrice"
                                      placeholder="Selling Price"
                                      onChange={(e) =>
                                        handleSellingPriceChange(
                                          e,
                                          poItem.id,
                                          i,
                                        )
                                      }
                                      value={Number(poItem.selling_price) || ""}
                                    />
                                    {poItem.sellingPriceError}
                                  </div>
                                  <div className="modal-card-row">
                                    <label>Margin</label>
                                    <div
                                      style={{
                                        color: poItem.marginColor || "black",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {poItem.marginValue && poItem.rangeLabel
                                        ? `${poItem.marginValue}% (${poItem.rangeLabel})`
                                        : poItem.marginValue
                                          ? `${poItem.marginValue}%`
                                          : poItem.rangeLabel || ""}
                                    </div>
                                  </div>
                                  {poItem.item_code &&
                                  (poItem.barcode !== null
                                    ? poItem.barcode.trim()[0] == "F"
                                    : true) ? (
                                    <div className="modal-card-row">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={barcodenotification}
                                      >
                                        <Button
                                          onClick={() => onPrintClick(i)}
                                          style={{ border: "none" }}
                                        >
                                          <i className="fa fa-barcode" />
                                        </Button>
                                      </OverlayTrigger>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      </form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        bsStyle="danger"
                        fill
                        onClick={() => (
                          setAddToInventoryModalNew(false),
                          setAddToInventoryValues([]),
                          setConfirmPrice(false),
                          setConfirmQty(false),
                          setConfirmBonus(false)
                        )}
                      >
                        Cancel
                      </Button>
                      {/* {store_id === 1 || store_id === null ? ( */}
                      <Button
                        onClick={() => handleOnSubmitNew()}
                        bsStyle="success"
                        fill
                        disabled={isInventorySubmitting}
                      >
                        {isInventorySubmitting ? "Submitting..." : "Submit"}
                      </Button>
                      {/* ) : ( */}
                      {/* <Button
                          onClick={() => handleSubmitNew()}
                          bsStyle="success"
                          fill
                          disabled={!isSubmitEnabled}
                        >
                          Submit
                        </Button>
                      )} */}
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={openGRNModal}
                    onHide={() => setOpenGRNModal(false)}
                    bsSize="large"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Goods Receipt Note (GRN)</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: "20px 40px" }}>
                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>Location & Address</ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl
                              type="text"
                              placeholder="Enter address"
                            />
                          </Col>
                        </Row>
                      </FormGroup>

                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>Date of Receipt</ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl type="date" />
                          </Col>
                        </Row>
                      </FormGroup>

                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>GRN No.</ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl
                              type="text"
                              placeholder="Enter GRN No."
                            />
                          </Col>
                        </Row>
                      </FormGroup>

                      <hr />

                      <h5>PART A: Agent / Depositor Details</h5>
                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>Agent / Depositor Name</ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl type="text" placeholder="Enter name" />
                          </Col>
                        </Row>
                      </FormGroup>

                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>Telephone No.</ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl
                              type="text"
                              placeholder="Enter phone number"
                            />
                          </Col>
                        </Row>
                      </FormGroup>

                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>Fax No.</ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl
                              type="text"
                              placeholder="Enter fax number"
                            />
                          </Col>
                        </Row>
                      </FormGroup>

                      <hr />

                      <h5>PART B: Details by Beneficiary</h5>
                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>DP ID</ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl
                              type="text"
                              placeholder="Enter DP ID"
                            />
                          </Col>
                        </Row>
                      </FormGroup>

                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>DP Name</ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl
                              type="text"
                              placeholder="Enter DP Name"
                            />
                          </Col>
                        </Row>
                      </FormGroup>

                      <FormGroup>
                        <Row>
                          <Col sm={4}>
                            <ControlLabel>
                              Beneficiary / Client Name
                            </ControlLabel>
                          </Col>
                          <Col sm={8}>
                            <FormControl
                              type="text"
                              placeholder="Enter Beneficiary Name"
                            />
                          </Col>
                        </Row>
                      </FormGroup>

                      {/* Continue similarly for Part C, Part D, and Part E */}

                      <hr />
                      <div className="table-responsive">
                        <Table className="fl_order_details">
                          <thead>
                            <tr>
                              <th
                                align="center"
                                width="10"
                                style={{ textAlign: "center" }}
                              >
                                <ControlLabel>Item</ControlLabel>
                              </th>
                              <th
                                align="center"
                                style={{ textAlign: "center" }}
                              >
                                <ControlLabel>B: No</ControlLabel>
                              </th>
                              <th
                                align="center"
                                style={{ textAlign: "center" }}
                              >
                                <ControlLabel>Barcode</ControlLabel>
                              </th>
                              <th
                                align="center"
                                style={{ textAlign: "center" }}
                              >
                                <ControlLabel>Qty</ControlLabel>
                              </th>
                              <th
                                align="center"
                                style={{ textAlign: "center" }}
                              >
                                <ControlLabel>Amount</ControlLabel>
                              </th>
                              <th
                                align="center"
                                style={{ textAlign: "center" }}
                              >
                                <ControlLabel>Expiry Date</ControlLabel>
                              </th>
                              <th
                                align="center"
                                style={{ textAlign: "center" }}
                              >
                                <ControlLabel>Selling Price</ControlLabel>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {addToInventoryValues &&
                              addToInventoryValues.map((poItem, i) => (
                                <tr>
                                  <>
                                    {/* <p>{poItem.expiaryDateError}</p> */}
                                    <td align="center" style={{ width: "15%" }}>
                                      <FormGroup>
                                        <FormControl
                                          type="text"
                                          name="name"
                                          placeholder="Medicine Item "
                                          value={poItem.name}
                                          disabled
                                        />
                                      </FormGroup>
                                    </td>
                                    <td align="center" style={{ width: "15%" }}>
                                      <FormGroup>
                                        <FormControl
                                          type="text"
                                          name="batch_no"
                                          placeholder="Batch No"
                                          value={poItem.batch_no}
                                          disabled
                                        />
                                      </FormGroup>
                                    </td>
                                    <td align="center" style={{ width: "15%" }}>
                                      <FormGroup>
                                        <FormControl
                                          type="text"
                                          name="barcode_no"
                                          placeholder="Barcode"
                                          onChange={(value) =>
                                            handleBarcodeChange(
                                              value,
                                              poItem.id,
                                              i,
                                            )
                                          }
                                          value={poItem.barcode}
                                          disabled={
                                            poItem.barcode !== null
                                              ? poItem.barcode[0] === "F"
                                              : false
                                          }
                                        />
                                      </FormGroup>
                                    </td>
                                    <td align="center" style={{ width: "10%" }}>
                                      <FormGroup>
                                        <FormControl
                                          type="text"
                                          name="qty"
                                          placeholder="Quantity "
                                          value={
                                            poItem.quantity +
                                            poItem.free_of_goods
                                          }
                                          disabled
                                        />
                                      </FormGroup>
                                    </td>
                                    <td align="center" style={{ width: "15%" }}>
                                      <FormGroup>
                                        <FormControl
                                          type="text"
                                          name="unit_price"
                                          placeholder="Unit Price "
                                          value={JSON.parse(
                                            poItem.price,
                                          ).toFixed(2)}
                                          disabled
                                        />
                                      </FormGroup>
                                    </td>
                                    <td align="center" style={{ width: "15%" }}>
                                      <FormGroup>
                                        <Datetime
                                          timeFormat={false}
                                          dateFormat="YYYY-MM-DD"
                                          inputProps={{
                                            placeholder: "Expiary Date",
                                          }}
                                          closeOnSelect={true}
                                          onChange={(value) =>
                                            handleExpiaryDateChange(
                                              value,
                                              poItem.id,
                                              i,
                                            )
                                          }
                                          isValidDate={disablePastDt}
                                        />
                                        {poItem.expiaryDateError}
                                      </FormGroup>
                                    </td>
                                    <td align="center" style={{ width: "15%" }}>
                                      <FormGroup>
                                        <FormControl
                                          type="number"
                                          name="sellingPrice"
                                          placeholder="Selling Price "
                                          onChange={(e) =>
                                            handleSellingPriceChange(
                                              e,
                                              poItem.id,
                                              i,
                                            )
                                          }
                                        />
                                        {poItem.sellingPriceError}
                                      </FormGroup>
                                    </td>
                                    {poItem.item_code &&
                                    (poItem.barcode !== null
                                      ? poItem.barcode.trim()[0] == "F"
                                      : true) ? (
                                      <>
                                        <td>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={barcodenotification}
                                          >
                                            <Button
                                              onClick={handlePrint}
                                              style={{
                                                border: "none",
                                                marginBottom: "10px",
                                              }}
                                            >
                                              <i
                                                class="fa fa-barcode"
                                                aria-hidden="true"
                                              ></i>
                                            </Button>
                                          </OverlayTrigger>
                                        </td>
                                        <td style={{ display: "none" }}>
                                          <div
                                            ref={barcodeRef}
                                            className="print-only"
                                          >
                                            <BarcodeInput
                                              name={poItem.name}
                                              itemcode={poItem.item_code}
                                            />
                                          </div>
                                        </td>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                      </div>

                      <FormGroup>
                        <Row>
                          <Col sm={12}>
                            <ControlLabel>Note:</ControlLabel>
                            <div
                              style={{
                                border: "1px solid #ccc",
                                padding: "10px",
                                borderRadius: "5px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              I have gone through the terms and conditions of
                              storage and agree to abide by the same. I hereby
                              give declaration that the commodities being
                              deposited herein belong to the beneficiary as
                              stated above and are free from any encumbrances. I
                              request you to take the custody of the said
                              commodities for which I undertake to indemnify you
                              against any losses incurred by you due to any
                              false information provided by me/any
                              misrepresentation of facts on my part. Commodities
                              stored with you shall not contain any explosive,
                              harmful pesticides, chemicals, drugs. I shall be
                              liable to pay all charges due from time to time as
                              per charges schedule along with mandi tax for the
                              commodities stored with you.
                            </div>
                          </Col>
                        </Row>
                      </FormGroup>
                      <hr />

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <ControlLabel>Date:</ControlLabel>
                          <span>Format No. QR/RWH-04</span>
                        </div>
                        <div>
                          <span>Version No. 02</span>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button className="btn-color" fill>
                        Print
                      </Button>
                      &nbsp;
                      <Button
                        className="btn-color"
                        fill
                        onClick={() => setOpenGRNModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </Col>
              </Row>
              {isPDFLoading && <ScreenLoader />}
              {isGRNLoading && <ScreenLoader />}
            </React.Fragment>
          }
        />
      </Col>
      {openAttachmentModal && (
        <AttachmentModal
          show={openAttachmentModal}
          onHide={() => setOpenAttachmentModal(false)}
          poDetails={poDetailsForAttachment}
        />
      )}
      <ViewPoMedicine
        show={viewMedicineModal}
        onHide={() => setViewMedicineModal(false)}
        setPoListDataById={setPoListDataById}
        poListDataById={poListDataById}
      />
    </>
  );
};

export default PoList;
